import type { SVGProps } from 'react';

const SvgPointWhiteBg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    fill='none'
    height='1em'
    viewBox='0 0 24 24'
    width='1em'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M9.99 17.98C14.4028 17.98 17.98 14.4028 17.98 9.99C17.98 5.57724 14.4028 2 9.99 2C5.57724 2 2 5.57724 2 9.99C2 14.4028 5.57724 17.98 9.99 17.98Z'
      fill='currentColor'
    />
    <path
      d='M9.61384 11.6951C9.55443 11.6951 9.51482 11.7092 9.49502 11.7372C9.47521 11.7583 9.46531 11.7969 9.46531 11.853V13.4004C9.46531 13.4986 9.44221 13.5688 9.396 13.6109C9.3564 13.653 9.29038 13.6741 9.19797 13.6741H7.99987C7.91406 13.6741 7.84805 13.653 7.80184 13.6109C7.76223 13.5618 7.74243 13.4916 7.74243 13.4004V6.57935C7.74243 6.4811 7.76223 6.41093 7.80184 6.36882C7.84805 6.32672 7.91406 6.30566 7.99987 6.30566H10.3268C12.3665 6.30566 13.3864 7.19338 13.3864 8.96882C13.3864 9.86707 13.119 10.5478 12.5843 11.0109C12.0496 11.4671 11.274 11.6951 10.2574 11.6951H9.61384ZM9.61384 7.98987C9.55443 7.98987 9.51482 8.00391 9.49502 8.03198C9.47521 8.05303 9.46531 8.09163 9.46531 8.14777V9.85303C9.46531 9.90917 9.47521 9.95128 9.49502 9.97935C9.51482 10.0004 9.55443 10.0109 9.61384 10.0109H10.2574C10.6997 10.0109 11.0331 9.92672 11.2575 9.7583C11.4885 9.58286 11.6041 9.32321 11.6041 8.97935C11.6041 8.63549 11.4918 8.38637 11.2674 8.23198C11.0496 8.07058 10.7129 7.98987 10.2574 7.98987H9.61384Z'
      fill='white'
    />
    <path
      d='M21.97 15.99C21.97 19.29 19.29 21.97 15.99 21.97C13.95 21.97 12.16 20.95 11.08 19.4C15.44 18.91 18.91 15.44 19.4 11.08C20.95 12.16 21.97 13.95 21.97 15.99Z'
      fill='currentColor'
      opacity='0.4'
    />
  </svg>
);
export default SvgPointWhiteBg;
